﻿import * as paths from '../utils/paths';

export default class GisSettingsHandler {
    constructor(rootURL) {
        this.rootURL = rootURL;
        this.settings = {};
    }

    load() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: this.rootURL + paths.MAP_GIS_SETTINGS_URL,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    this.settings = result;
                    resolve();
                },
                error: (e) => {
                    reject(e);
                }
            });
        });
    }
}